<script setup>
import { ref, onMounted, watch, computed } from 'vue'
import { Rive, Fit, Layout } from '@rive-app/canvas'
import CrownsTicker from '@components/global/accents/CrownsTicker.vue'

const props = defineProps(['award'])
const variant = computed(() => Math.floor(Math.random() * 3))

const canvas = ref(null)
const isHovering = ref(false)

onMounted(() => {
	const rive = new Rive({
		canvas: canvas.value,
		src: 'https://cdn.papercrowns.com/website/rive/banner-alt-2.riv',
		autoplay: true,
		autoBind: true,
		layout: new Layout({
			fit: Fit.Contain,
		}),
		stateMachines: 'crownsStateMachine',
		onLoad: () => {
			let vmi = rive.viewModelInstance
			const booleanProperty = vmi.boolean('isHovered')
			booleanProperty.value = false
		},
	})

	watch(isHovering, (newValue) => {
		const hover = rive.viewModelInstance.boolean('isHovered')
		hover.value = newValue
	})
})
</script>

<template>
	<button class="group flex flex-col items-start border border-crowns-grey bg-crowns-dark-grey bg-waves-pattern bg-cover p-5 transition-all duration-500 hover:bg-crowns-grey" @mouseenter="isHovering = true" @mouseleave="isHovering = false">
		<div class="flex w-full justify-between text-xs uppercase text-crowns-castle-stone">
			<div>{{ award.year }}</div>
			<div>{{ award.month }}</div>
		</div>
		<div>
			<div :class="['relative m-8 flex items-center justify-center transition-transform duration-200 ease-in-out group-hover:scale-105', { 'rotate-3': variant == 1 }, { '-rotate-3': variant == 2 }]">
				<img class="absolute z-10 mb-[25%] max-h-[30%] max-w-[40%]" :src="award.logo" alt="" />
				<canvas class="w-full grayscale transition-all duration-300 group-hover:grayscale-0" height="512" width="512" ref="canvas"></canvas>
				<!-- <img class="brightness-150 grayscale transition-all duration-300 group-hover:brightness-100 group-hover:grayscale-0" src="https://cdn.papercrowns.com/website/images/elements/etches/banner-gold.png" alt="" /> -->
			</div>
			<div class="flex flex-col items-center gap-2">
				<div class="text-xl font-semibold leading-[1.1]">{{ award.name }}</div>
				<div class="text-xs text-crowns-castle-stone">{{ award.subtitle }}</div>
			</div>
		</div>
	</button>
</template>
